import { Set as ImmutableSet } from 'immutable';
import * as Actions from 'FormsUI/actions/Gates';
export function gates(state = ImmutableSet(), action) {
  switch (action.type) {
    case Actions.SET_GATES:
      return action.gates;
    default:
      return state;
  }
}